import {FormatConfigEntry, FormatConfigResponse} from "../base-api";
import {isNull} from "util";

export class AppFormatConfig {

  private formatConfig;

  constructor(formatConfigResponse: FormatConfigResponse) {
    this.formatConfig = formatConfigResponse;
  }

  getFormat(type: FormatConfigEntry.TypeEnum, path: string, locationStrategy: string): FormatConfigEntry {
    if (this.formatConfig) {
      if (!type) {
        throw new Error("No type declared for Kompaktdarstellung " + path ? path : "");
      }
      if (path && locationStrategy) {
        const found = this.formatConfig.entries.find(a => a.type === type && (a.path === path || path.includes(a.path)) && a.componentId === locationStrategy);
        if (found) {
          return found;
        }
      }
      if (path) {
        const found = this.formatConfig.entries.find(a => a.type === type && (a.path === path || path.includes(a.path)) && isNull(a.componentId));
        if (found) {
          return found;
        }
      }
      if (locationStrategy) {
        const found = this.formatConfig.entries.find(a => a.type === type && isNull(a.path) && a.componentId === locationStrategy);
        if (found) {
          return found;
        }
      }
      return this.formatConfig.entries.find(a => a.type === type && isNull(a.path) && isNull(a.componentId));
    }
    throw new Error("Format not loaded " + path ? path : "");
  }

}
